import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'suka-tab',
  template: `
    <div [hidden]="!active" class="tabs__tab-item">
      <ng-content></ng-content>
    </div>
  `,
})
export class TabItem {
  /**
   * Sets the tab title.
   */
  @Input() title: string | TemplateRef<any>;

  /**
   * Set to `true` to activate the tab (display it).
   */
  @Input() active = false;

  /**
   * Callback when the tab is selected.
   */
  @Output() selected = new EventEmitter<string | TemplateRef<any>>();

  constructor(private cdRef: ChangeDetectorRef) { }

  /**
   * Activates tab item
   */
  activate(): void {
    this.active = true;
    this.cdRef.detectChanges();
    this.selected.emit(this.title);
  }
}
